<script lang="ts" setup>
import { selectItem, TextField, ValueField } from '@/models/select-item'
import FilterContainer from '../filter/FilterContainer.vue'
import useJournalColumns from './columns'
import MultiSelectFilter from '../filter/MultiSelectFilter.vue'

const props = defineProps({
	component: { default: 'journal' },
})

const { columns, all } = useJournalColumns(props.component)
</script>
<template>
	<FilterContainer :columns="all" bookmark="data-assets-bookmark">
		<div class="p-2 filter-col" v-if="columns.table.value.isVisible">
			<MultiSelectFilter
				id="personal-data-filter-data-asset"
				:label-field="TextField"
				:value-field="ValueField"
				:options="[selectItem('Riskid', 'risk_meta')]"
				v-model="columns.table.value"
			/>
		</div>
	</FilterContainer>
</template>
